var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacilities(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 0C1.00736 0 0 1.00736 0 2.25V19.5C0 20.3284 0.671573 21 1.5 21V2.25C1.5 1.83579 1.83579 1.5 2.25 1.5H21C21 0.671572 20.3284 0 19.5 0H2.25Z",
    fill: "#43AC43"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 3C4.00736 3 3 4.00736 3 5.25V21.75C3 22.9926 4.00736 24 5.25 24H14.3787C14.9754 24 15.5477 23.7629 15.9697 23.341L23.341 15.9697C23.7629 15.5477 24 14.9754 24 14.3787V5.25C24 4.00736 22.9926 3 21.75 3H5.25ZM4.5 5.25C4.5 4.83579 4.83579 4.5 5.25 4.5H21.75C22.1642 4.5 22.5 4.83579 22.5 5.25V13.5H15.75C14.5074 13.5 13.5 14.5074 13.5 15.75V22.5H5.25C4.83579 22.5 4.5 22.1642 4.5 21.75V5.25ZM15 22.1893V15.75C15 15.3358 15.3358 15 15.75 15H22.1893L15 22.1893Z",
    fill: "#43AC43"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacilities);
export default __webpack_public_path__ + "static/media/facilities.fb4b0f7300ef6dcaf51eb323ab6d19f3.svg";
export { ForwardRef as ReactComponent };